export default __webpack_public_path__ + "static/media/5.7bd337d2.png";